export default function (cls) {
  // 获取我的文件列表
  cls.prototype.fetchFileList = async function ({ page, cloud_folder_id = '', keyword = '' }) {
    const response = await cls.request({
      url: '/sys/member/cloud/storage/index',
      query: {
        page,
        cloud_folder_id,
        keyword
      }
    })
    return response.results
  }
  // 添加我的文件夹
  cls.prototype.addFolder = async function ({ parent_folder_id = '', cloud_folder_name = '' }) {
    const response = await cls.request({
      method: 'post',
      url: '/sys/member/cloud/folder/add',
      data: {
        parent_folder_id,
        cloud_folder_name
      }
    })
    return response
  }
  // 变更我的文件夹或文件名称(重命名)
  cls.prototype.renameFile = async function ({ cloud_file_id = '', cloud_file_name = '' }) {
    const response = await cls.request({
      method: 'post',
      url: '/sys/member/cloud/file/edit',
      data: {
        cloud_file_id,
        cloud_file_name
      }
    })
    return response
  }
  // 文件上传
  cls.prototype.uploadFile = async function ({ parent_folder_id = '', cloud_file_params = '' }) {
    const response = await cls.request({
      method: 'post',
      url: '/sys/member/cloud/file/upload',
      data: {
        parent_folder_id,
        cloud_file_params
      }
    })
    return response
  }
  // 删除文件
  cls.prototype.delFile = async function ({cloud_file_id}) {
    const response = await cls.request({
      method: 'post',
      url: '/sys/member/cloud/file/delete/${cloud_file_id}',
      params: { cloud_file_id }
    })
    return response
  }
  // 我的云盘目录文件夹结构
  cls.prototype.fetchFolderList = async function () {
    const response = await cls.request({
      url: '/sys/member/cloud/folder/list'
    })
    return response.results
  }
  // 移动文件或文件夹
  cls.prototype.moveFile = async function ({ source_file_id = '', target_folder_id = '' }) {
    const response = await cls.request({
      method: 'post',
      url: '/sys/member/cloud/file/move',
      data: {
        source_file_id,
        target_folder_id
      }
    })
    return response
  }
  // 获取要分享的文件的信息
  cls.prototype.fetchFileDetail = async function ({ cloud_file_code = '' }) {
    const response = await cls.request({
      url: '/sys/member/cloud/file/detail/${cloud_file_code}',
      params: { cloud_file_code }
    })
    return response.results
  }
  // 分享文件
  cls.prototype.shareFile = async function ({ cloud_file_code = '', expired_days = 1 }) {
    const response = await cls.request({
      method: 'post',
      url: '/sys/member/cloud/file/share/add',
      data: {
        cloud_file_code,
        expired_days
      }
    })
    return response
  }
  // 获取文件分享的日志信息
  cls.prototype.fetchShareFileDetail = async function ({ cloud_file_code = '', share_log_id = '' }) {
    const response = await cls.request({
      url: '/sys/cloud/file/share/detail/${cloud_file_code}/${share_log_id}',
      params: { cloud_file_code, share_log_id }
    })
    return response.results
  }
  // 保存文件
  cls.prototype.saveFile = async function ({ cloud_file_code = '', parent_folder_id = '', share_log_id = '' }) {
    const response = await cls.request({
      method: 'post',
      url: '/sys/member/cloud/file/share/save',
      data: {
        cloud_file_code,
        parent_folder_id,
        share_log_id
      }
    })
    return response
  }
  // 会员开通云盘
  cls.prototype.openCloudStorage = async function () {
    const response = await cls.request({
      method: 'post',
      url: '/sys/member/cloud/storage/open'
    })
    return response
  }
  // 获取我的分享文件列表
  cls.prototype.fetchMySharedFileList = async function ({ page, keyword = '' }) {
    const response = await cls.request({
      url: '/sys/member/cloud/file/share/list',
      query: {
        page,
        keyword
      }
    })
    return response.results
  }
  cls.prototype.fetchMySharedFileDetail = async function ({ share_log_id = '' }) {
    const response = await cls.request({
      url: '/sys/member/cloud/file/share/detail/${share_log_id}',
      params: {
        share_log_id
      }
    })
    return response.results
  }
  cls.prototype.cancelMySharedFile = async function ({ cloud_file_code = '', share_log_id = '' }) {
    const response = await cls.request({
      method: 'post',
      url: '/sys/member/cloud/file/share/cancel',
      data: {
        cloud_file_code,
        share_log_id
      }
    })
    return response
  }
}



// WEBPACK FOOTER //
// ./src/modules/member/api/cloudstorageApi.js